module.exports = new Promise(resolve => {
    let remoteUrl = 'https://factoring-client-management.rtspro.dev/remoteEntry.js'
    const appName = document.querySelector('meta[name="application-name"]')?.content
    if (window.location.hostname.includes('localhost') && appName === 'internalappsclientmanagement') remoteUrl = 'https://localhost:8091/remoteEntry.js'
    const script = document.createElement('script')
    script.src = remoteUrl
    script.onload = () => {
      const proxy = {
        get: (request) => window.internalappsclientmanagement.get(request),
        init: (...arg) => {
          try {
            return window.internalappsclientmanagement.init(...arg)
          } catch(e) {
            console.log('remote container already initialized')
          }
        }
      }
      resolve(proxy)
    }
    document.head.appendChild(script);
  })
  ;